import z from 'zod';
export const reportProgressWebhookSchema = z.looseObject({
    type: z.literal('report-progress'),
    projectId: z.string(),
    reportId: z.string(),
    progress: z.number(),
});
//# sourceMappingURL=report-progress.webhook.js.map